import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from './QueryProvider';
import { RTLProvider, useDirection } from './RTLProvider';
import { Toaster } from 'sonner';

/**
 * Inner component that uses direction context
 */
function AppContent({ children }) {
  const { direction } = useDirection();

  return (
    <BrowserRouter>
      {children}
      <Toaster
        position="top-center"
        richColors
        closeButton
        dir={direction}
      />
    </BrowserRouter>
  );
}

/**
 * Combined App Providers
 * Wraps all providers in the correct order
 */
export function AppProviders({ children }) {
  return (
    <QueryProvider>
      <RTLProvider defaultLocale="ar">
        <AppContent>{children}</AppContent>
      </RTLProvider>
    </QueryProvider>
  );
}
